/* ============================================================
   Aperçu "votre logo" sur les cartes produit
   ------------------------------------------------------------
   Quand un client a uploadé un logo dans l'éditeur de produit,
   l'URL publique du logo est mémorisée en localStorage (pe_logo_preview).
   Ce script superpose ce logo sur chaque carte produit qui expose
   sa zone imprimable front via data-pe-card-zone (JSON de la zone,
   coords normalisées 0..1 relatives à l'image front du produit).

   Le logo est centré dans la zone et contenu dedans (jamais de
   débordement) ; la zone elle-même n'est PAS dessinée.

   Couvre aussi les cartes injectées en AJAX (recommandations panier,
   quick-view…) via MutationObserver.
   ============================================================ */
(function () {
  var KEY = 'pe_logo_preview';
  var MAX_AGE = 7 * 24 * 3600 * 1000; // 7 jours

  function getLogoUrl() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.url) return null;
      if (data.at && Date.now() - data.at > MAX_AGE) {
        localStorage.removeItem(KEY);
        return null;
      }
      return data.url;
    } catch (e) {
      return null;
    }
  }

  var logoUrl = getLogoUrl();
  if (!logoUrl) return;

  // Style global : conteneur + masquage au survol quand l'image secondaire s'affiche.
  // !important partout sur l'img : les thèmes appliquent souvent des règles globales
  // aux images des cartes (width:100%, position:absolute, object-fit:cover…) qui
  // feraient déborder le logo de sa zone.
  var style = document.createElement('style');
  style.textContent =
    '.pe-logo-preview{position:absolute;display:flex;align-items:center;justify-content:center;' +
    'pointer-events:none;z-index:2;overflow:hidden;transition:opacity .2s ease;}' +
    '.pe-logo-preview img{' +
    'position:static!important;inset:auto!important;display:block!important;' +
    'width:auto!important;height:auto!important;' +
    'max-width:90%!important;max-height:90%!important;' +
    'min-width:0!important;min-height:0!important;' +
    'object-fit:contain!important;transform:none!important;' +
    'border-radius:0!important;box-shadow:none!important;opacity:1!important;}' +
    '.tc-card__img-wrap:has(.tc-card__img--secondary):hover .pe-logo-preview{opacity:0;}';
  document.head.appendChild(style);

  function decorateOne(wrap) {
    if (wrap.__peDecorated) return;
    var zone;
    try {
      zone = JSON.parse(wrap.getAttribute('data-pe-card-zone'));
    } catch (e) {
      return;
    }
    if (!zone || zone.width == null || zone.height == null) return;

    var img =
      wrap.querySelector('.tc-card__img--primary') || wrap.querySelector('img:not(.pe-logo-preview img)');
    if (!img) return;

    wrap.__peDecorated = true;
    if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';

    var holder = document.createElement('div');
    holder.className = 'pe-logo-preview';
    holder.setAttribute('aria-hidden', 'true');
    holder.innerHTML = '<img src="' + logoUrl.replace(/"/g, '') + '" alt="" loading="lazy">';
    wrap.appendChild(holder);
    var logoImg = holder.querySelector('img');

    // Le backend supprime automatiquement une image jamais commandée après
    // 30 jours : si l'URL ne répond plus, on retire l'aperçu partout et on
    // oublie la référence, plutôt que d'afficher une image cassée.
    logoImg.addEventListener('error', function () {
      try {
        localStorage.removeItem(KEY);
      } catch (e) {}
      var stale = document.querySelectorAll('.pe-logo-preview');
      for (var i = 0; i < stale.length; i++) stale[i].remove();
    });

    // Positionne la zone par rapport à la boîte réellement rendue de l'image
    // (gère le letterboxing si l'image ne remplit pas tout le wrapper), puis
    // dimensionne le logo EN PIXELS pour qu'il soit contenu dans la zone
    // (style inline !important : imbattable par le CSS du thème).
    function place() {
      var wr = wrap.getBoundingClientRect();
      var ir = img.getBoundingClientRect();
      if (!ir.width || !ir.height) return;
      var zw = zone.width * ir.width;
      var zh = zone.height * ir.height;
      holder.style.left = ir.left - wr.left + zone.x * ir.width + 'px';
      holder.style.top = ir.top - wr.top + zone.y * ir.height + 'px';
      holder.style.width = zw + 'px';
      holder.style.height = zh + 'px';

      if (logoImg.naturalWidth && logoImg.naturalHeight && zw > 0 && zh > 0) {
        // contain : le logo tient entièrement dans la zone (marge de 10 %)
        var scale = Math.min((zw * 0.9) / logoImg.naturalWidth, (zh * 0.9) / logoImg.naturalHeight);
        logoImg.style.setProperty('width', Math.max(1, logoImg.naturalWidth * scale) + 'px', 'important');
        logoImg.style.setProperty('height', Math.max(1, logoImg.naturalHeight * scale) + 'px', 'important');
        logoImg.style.setProperty('max-width', 'none', 'important');
        logoImg.style.setProperty('max-height', 'none', 'important');
      }
    }

    if (img.complete) place();
    img.addEventListener('load', place);
    if (logoImg.complete) place();
    logoImg.addEventListener('load', place);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(place).observe(img);
    } else {
      window.addEventListener('resize', place);
    }
  }

  function decorate(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[data-pe-card-zone]').forEach(decorateOne);
  }

  function init() {
    decorate(document);

    // Cartes injectées après coup (recommandations panier, sliders, quick-view…)
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        decorate(document);
      }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
